/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
import moment from 'moment';
import fc     from '@/util/interface';
import off    from '@/util/offline';


export default class Model extends off {                 
        
    api     = fc.biz4;    
    backend = '*';
    entity  = '*';
    route   = '';
    vuex    = false;              
    
    constructor(){        
        super();
    }
    
    store(){
        return window.getApp.$store;
    }
    
    state(){
        return this.store().state;
    }
    
    isOnline(){
        //return true;
        return window.navigator.onLine;
    }
    
    all(params = {}){                        
        return this.vuex ? this.allOfflinePromise(this.entity, params) : this.allOnline(params);
    }    
    
    one(params = {}){
        return this.vuex ? this.oneOfflinePromise(this.entity, params) : this.oneOnline(params);   
    }
    
    create(data, params={}){
        data.flag = 'create';
        return this.vuex ? this.createOffline(this.entity, data) : this.createOnline(data, params);                 
    }       
    
    update(data, params={}){
        data.flag = data.flag == 'create' || data.flag == 'notif-create' ? 'create' : 'update';        
        return this.vuex ? this.updateOffline(this.entity, data) : this.updateOnline(data, params);                 
    }

    view(params = {}){
        return this.api.get(this.backend + 'view', params).then(res =>{
            return res.status === 200? res.data : {};
        })
    }    

    delete(data, params={}){        
        return this.vuex ? this.deleteOffline(this.entity, data) : this.deleteOnline(data, params);         
    }
                                           
    allOnline(params = {}){
        return this.api.get(this.backend + 'index', params).then(res => {
            return res.status === 200 ? res.data : [];
        });
    }
    
    oneOnline(params = {}){
        return this.api.get(this.backend + 'findbyid', params).then(res =>{
            return res.status === 200? res.data : [];
        })
    }
    
    createOnline(data, params={}){
        return this.api.post(this.backend + 'create', data, params);
    }
    
    updateOnline(data, params={}){
        return this.api.post(this.backend + 'update', data, params);        
    }
    
    deleteOnline(data, params={}){
        return this.api.post(this.backend + 'delete', data, params);        
    }
    
    fetch(){
        var lastTimeServer = (this.state().timeServer);
        //lastTimeServer = 0;
        return this.api.get(this.backend + 'fetch', {time : lastTimeServer}).then(res => {            
            if(res.status === 200){
                var items   = res.data.data;
                var time    = res.data.time;
                var mergeID = []; 
                
                items.forEach((value) => {
                    var data = this.oneOffline(this.entity, {id : value.id});                                                                                    
                    if(data === null){                 
                        if(!value.deleted){
                            this.createOfflineTime(this.entity, {time: time, data: value});
                        }                       
                    } else if(data.flag === null){                         
                        if(value.deleted){
                            this.deleteOfflinePermanen(this.entity, data);
                        } else {
                            this.updateOfflineTime(this.entity, {time: time, data: value});                             
                        }
                    } else {                                                
                        if(data.flag != 'create'){                               
                            if(!value.deleted){                                
                                if(data.flag == 'notif-create'){                                    
                                    //console.log('ini terus');
                                    value.flag = null;
                                    this.updateOffline(this.entity, value);
                                    data.id = null;
                                    this.createOffline(this.entity, data);
                                } else {
                                    //console.log(data); 
                                    data.flag = 'notif';
                                    data.info =  {action : 'fetch', data : value, db:this.entity};
                                    mergeID.push(value.id);
                                    this.updateOfflineTime(this.entity, {time: time, data: data});
                                }                                                                
                            } else {                                
                                this.deleteOfflinePermanen(this.entity, data);
                            }
                        } else {
                            if(!value.deleted){
                                data.id = null;                                
                                this.createOfflineTime(this.entity, {time: time, data: value});
                                this.updateOfflineTime(this.entity, {time: time, data: data}); 
                            }
                        }
                    }                                        
                })                                
                
                if(mergeID.length !== 0){
                    let prevNotice = this.oneOffline('notifications', { id : 'fetch-' + this.entity});                            
                    let dataPrevNotice = prevNotice == null ? [] : prevNotice.ref.id;
                    var isNewNotif = false;
                    
                    mergeID.forEach(val => {
                        if(!this.inArray(val, dataPrevNotice)){
                            isNewNotif = true;
                            dataPrevNotice.push(val);
                        }
                    });
                                         
                    if(isNewNotif){                    
                        this.saveNotif(
                            'fetch-' + this.entity,
                            'Conflig Fetch Database '+this.entity+' Detected !', 
                            'Please Resolve the conflig data '+ this.entity,
                            {db : this.entity, id : dataPrevNotice, path: this.route},        
                            'fa-database',        
                        );
                    }
                }                 
                return true;
            }
            return false;
        });
    }
    
    synch(){
        var items = this.allOffline(this.entity);          
        items.forEach( data => {
            var result ;
            var noerror = false;
            //console.log(data);
            switch(data.flag){
                case 'create' : result = this.createOnline(data);  break;
                case 'update' : result = this.updateOnline(data);  break;
                case 'delete' : result = this.deleteOnline(data);  break;                
                default : noerror = true; break;
            }
            
            if(!noerror){
                result.then(res => {                    
                    if(res.status === 200){                       
                        if(res.data.deleted){                            
                            this.deleteOfflinePermanen(this.entity, data);
                        } else {           
                            if(data.flag == 'create' && res.data.id != data.id){                                
                                this.createOffline(this.entity, res.data);
                                this.deleteOfflinePermanen(this.entity, data);                                
                            }
                            res.data.flag = null;
                            this.updateOffline(this.entity, res.data);
                        }
                    } else { 
                                                                            
                        data.flag = data.flag == 'create' ? 'notif-create':'notif';
                        data.info = {action : 'synch', data : res.data, db:this.entity};
                        
                        this.updateOffline(this.entity, data);                        
                        var isNewNotif = false;
                        
                        let prevNotice = this.oneOffline('notifications', { id : 'synch-' + this.entity});                            
                        let dataPrevNotice = prevNotice == null ? [] : prevNotice.ref.id;
                        if(!this.inArray(data.id, dataPrevNotice)){
                            isNewNotif = true;
                            dataPrevNotice.push(data.id);
                        }
                                              
                        if(isNewNotif){
                            this.saveNotif(
                                'synch-' + this.entity,
                                'Data '+this.entity+' Validation Error', null,
                                {db : this.entity, id : dataPrevNotice, path: this.route}, 'fa-refresh', 'warning'         
                            );   
                        }      
                    }                    
                });
            } 
        });               
    }
    
    saveNotif(id, title=null, content=null, ref=null, icon=null, color=null){         
        title   = title ? title : 'Error Detected';
        content = content ? content : '';
        icon    = icon ? icon : 'fa-refresh';
        color   = color ? color : 'red';
        var time    = moment().valueOf();                       
        let notifikasi = {id:id,title:title,content:content,icon:icon,color:color,time:time,ref:ref};        
        this.createOrUpdateOffline('notifications', notifikasi);                                      
    }
    
    clearNotif(id){
        this.deleteOfflinePermanen('notifications', {id : id});        
    }
    
    inArray(needle, haystack = []) {
        var length = haystack.length;
        for(var i = 0; i < length; i++) {
            if(typeof haystack[i] == 'object') {
                if(arrayCompare(haystack[i], needle)) return true;
            } else {
                if(haystack[i] == needle) return true;
            }
        }
        return false;
    }
}